<template>
  <div class="salesmanfenliuserverPage">
      <div class="xr-mingxi">
        <mu-appbar class="xr-head" title="分流服务商">
            <mu-icon-button v-on:click="GoHistory" icon=":fa fa-angle-left" slot="left"/>
            <router-link  slot="right" to="/salesman/fenliuStream">
                <p >明细</p>
            </router-link>
        </mu-appbar>
      </div>
        <div class="gd-content">
            <h5>可分流<span>{{fenliuInfo.NowCount}}</span>分流套餐</h5>
            
            <div class="gt-form">
                <mu-row gutter>
                   <mu-col width="100" tablet="100" desktop="100" class="rowFiled">
                       <mu-text-field label="代理商" type="text" helpText=""  labelFloat fullWidth v-model="editInfo.UserName" />
                   </mu-col>
                    <mu-col width="100" tablet="100" desktop="100" class="rowFiled">
                       <mu-text-field label="数量" type="number" helpText="" labelFloat fullWidth v-model="editInfo.Count" maxLength="8" />
                   </mu-col>
              </mu-row>  
            </div>
            <mu-row class="gutter">
            <mu-col width="100" tablet="50" desktop="50" class="btn-div">          
            <mu-raised-button label="分流服务商" class="submit" primary fullWidth @click="submit()" />
            </mu-col>
            </mu-row> 
            <p class="desc">注：一个分流套餐等于一个创客套餐</p>
        </div>
    <XR-toast ref="XRtoast"></XR-toast>
    </div>
</template>
<script>

export default {
  data () {
        return {
            fenliuInfo:{
                NowCount:0,
            },
            editInfo:{
                SalesmanType:1, 
                UserName: '',
                Count: ''
            }
        }
    },
    mounted(){
        this.getInfo()
    },
    methods: {      
        GoHistory(){
        this.$router.goBack()
        },
        getInfo(){            
            var ths = this;  
            
            ths.$post(
                "/Salesman/SalesmanServer/GetFenLiuTotalByMinnerBm",{SalesmanType:1}
            ).then(function(res) {
                if(!res.IsSuccess){

                }else{
                    ths.fenliuInfo = res.Data
                }
            });
        },        
        submit: function(){
            var ths = this;  
            
            if(!this.editInfo.UserName){
                ths.$refs.XRtoast.failed('请输入代理商用户名', true)
                return
            }
            if(!this.editInfo.Count || this.editInfo.Count<=0){
                ths.$refs.XRtoast.failed('数量必须大于0', true)
                return
            }
            if(this.editInfo.Count>99999999){
                ths.$refs.XRtoast.failed('数量太大了', true)
                return
            }
            
            ths.$post(
                "/Salesman/SalesmanServer/FenLiuAgent", this.editInfo
            ).then(function(res) {
                if(!res.IsSuccess){
                    ths.$refs.XRtoast.failed(res.Msg, true)
                }else{
                    ths.editInfo.UserName = ''
                    ths.editInfo.Count = ''
                    ths.$refs.XRtoast.success(res.Msg, true)
                    ths.getInfo()
                }
            });
        },
    }
}
</script>
<style>
        body .salesmanfenliuserverPage{
            background: white;
            } 
        .salesmanfenliuserverPage .xr-mingxi .mu-appbar.fixed{  
            padding:0;
            position: fixed;
            top:0;
            left: 0;
            }
        .salesmanfenliuserverPage .xr-mingxi .mu-appbar-title {
            font-size: 16px;
            }
        .salesmanfenliuserverPage .xr-mingxi .title .mu-icon-button {
            position: absolute;
            left: 0;
            top: 0;
            color:white;
            }
        .salesmanfenliuserverPage .gd-content .gt-form{
            padding: 0 5%;
        }
        .salesmanfenliuserverPage .xr-mingxi .title .title-text {
            margin: 0;
            line-height: 48px;
            }
        .salesmanfenliuserverPage .xr-mingxi .right{
            margin: 0 8px;
            font-size: 16px
            }
        .salesmanfenliuserverPage .xr-mingxi .right a{
            color: #fff;
        }
        .salesmanfenliuserverPage .gd-content h5{   
            height: 47px;
            padding:20px 0;
            font-size:12px;
            font-weight:400;
            text-align:center;    
        }
      .salesmanfenliuserverPage  .gd-content h5 span{
            color:red;
        }
             
        .salesmanfenliuserverPage div.reg-prompt
        {   
            height: 37px;
            color:#999;
            text-align:right;
            font-size:13px;
            padding-right:5%;
            padding-bottom:10px;
        }
        .salesmanfenliuserverPage .row{
            padding: 0px 5%;
        }
        .salesmanfenliuserverPage .mu-text-field-content{
          padding: 0px ;
        }
       .salesmanfenliuserverPage .btn{
          text-align: center;
          padding: 2.8rem 2.5rem;
        }
        .salesmanfenliuserverPage .mu-raised-button{
         width: 100%;
       }
       .salesmanfenliuserverPage p.desc {
          line-height: 20px;
          font-size: .75rem;
          color: #666;
          margin-bottom: .2rem;
          padding: 0 5%;
        }
        .salesmanfenliuserverPage .gutter{
            padding: 0px;
        }
        .salesmanfenliuserverPage .forgetBtn {
            float: right;
            }

        .salesmanfenliuserverPage .btn-div {
            padding: 40px 5% 30px;
        }
        .salesmanfenliuserverPage .submit {
            height: 50px;
        }    
     
</style>


// WEBPACK FOOTER //
// src/pages/salesman/fenliuserver.vue